import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][ubiShowIfTruncated]',
})
export class ShowIfTruncatedDirective implements AfterViewInit, OnDestroy {
  constructor(
    private _matTooltip: MatTooltip,
    private _elementRef: ElementRef<HTMLElement>
  ) {}

  private _element = this._elementRef.nativeElement;
  private _resizeObserver = new ResizeObserver(this._setMatTooltipState.bind(this));

  public ngAfterViewInit(): void {
    this._resizeObserver.observe(this._element);
  }

  public ngOnDestroy(): void {
    this._resizeObserver.disconnect();
  }

  private _setMatTooltipState(entries: ResizeObserverEntry[]) {
    this._matTooltip.disabled = entries[0].target.scrollWidth <= entries[0].target.clientWidth;
  }
}
